{
  "name": "shipbook-console",
  "version": "2.43.0",
  "private": true,
  "engines": {
    "node": "26.x"
  },
  "dependencies": {
    "@babel/plugin-proposal-decorators": "^8.0.2",
    "@babel/plugin-transform-class-properties": "^8.0.1",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@eslint/js": "^10.0.1",
    "@microlink/react-json-view": "^1.31.22",
    "@react-oauth/google": "^0.13.5",
    "@shipbook/browser": "^1.2.0",
    "@types/js-cookie": "^3.0.6",
    "@types/lodash": "^4.17.24",
    "@types/node": "^26.1.0",
    "@types/react": "^19.2.17",
    "@types/react-copy-to-clipboard": "^5.0.7",
    "@types/react-datepicker": "^2.11.1",
    "@types/react-dom": "^19.2.3",
    "@types/react-geosuggest": "^2.7.10",
    "@types/react-highlight-words": "^0.20.1",
    "@types/react-router-dom": "^5.3.3",
    "@types/react-syntax-highlighter": "^15.5.13",
    "@types/react-tooltip": "^4.2.4",
    "@types/react-virtualized-auto-sizer": "^1.0.0",
    "@types/react-window": "^1.8.8",
    "@types/react-window-infinite-loader": "^1.0.3",
    "@typescript-eslint/eslint-plugin": "^8.62.1",
    "@typescript-eslint/parser": "^8.62.1",
    "@vitejs/plugin-react": "^6.0.3",
    "async-mutex": "^0.5.0",
    "diff": "^9.0.0",
    "eslint": "^10.6.0",
    "events": "^3.3.0",
    "js-cookie": "^3.0.8",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.18.1",
    "logrocket": "^12.1.1",
    "mobx": "^6.16.1",
    "mobx-react": "^9.2.2",
    "moment": "^2.29.1",
    "react": "^19.2.7",
    "react-copy-to-clipboard": "^5.1.1",
    "react-datepicker": "^2.16.0",
    "react-dom": "^19.2.7",
    "react-dropzone": "^15.0.0",
    "react-geosuggest": "^2.14.0",
    "react-highlight-words": "^0.21.0",
    "react-joyride": "^2.9.3",
    "react-phone-input-2": "^2.13.9",
    "react-router-dom": "^5.2.0",
    "react-select": "^5.10.2",
    "react-syntax-highlighter": "^16.1.1",
    "react-tooltip": "^4.2.15",
    "react-virtualized-auto-sizer": "^1.0.26",
    "react-window": "^1.8.6",
    "react-window-infinite-loader": "^1.0.5",
    "recharts": "^2.15.4",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.62.1",
    "vite": "^8.1.3"
  },
  "scripts": {
    "start": "vite",
    "build": "npm run lint && tsc && vite build",
    "preview": "vite preview",
    "test": "vitest run",
    "test:watch": "vitest",
    "lint": "eslint src/**/*.ts src/**/*.tsx",
    "test:e2e": "playwright test"
  },
  "devDependencies": {
    "@playwright/test": "^1.61.1",
    "jsdom": "^27.0.1",
    "msw": "^2.14.6",
    "vitest": "^4.1.9"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  }
}
